import React from 'react';
import DefaultLayout from '../../layouts/default';

import {
  DashboardProvider,
} from './context/DashboardContext';

// Import dashboard components
import RestaurantDashboardHeader from './components/RestaurantDashboardHeader';
import QuickReports from './components/QuickReports';
import TodaysChecklist from './components/TodaysChecklist';
import RotaToday from './components/RotaToday';
import TemperatureOverview from './components/TemperatureOverview';
import ComplianceCentre from './components/ComplianceCentre';
import RecentIncidents from './components/RecentIncidents';
import UpcomingExpiring from './components/UpcomingExpiring';

export default function DashboardPage() {
  return (
    <DashboardProvider>
      <DefaultLayout>

        <div className="w-full min-h-screen space-y-6">

          {/* Header Metrics */}
          <RestaurantDashboardHeader />

          {/* Quick Actions */}
          <QuickReports />

          {/* Dashboard Contents */}
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">

            {/* LEFT PANEL */}
            <div className="lg:col-span-7 space-y-6 flex flex-col">

              <TodaysChecklist />

              <TemperatureOverview />

              <ComplianceCentre />

            </div>

            {/* RIGHT PANEL */}
            <div className="lg:col-span-5 space-y-6 flex flex-col">

              <RotaToday />

              <RecentIncidents />

              <UpcomingExpiring />

            </div>

          </div>

        </div>

      </DefaultLayout>
    </DashboardProvider>
  );
}